var map = {
	"./2018-03-01-announcing-the-etc-cooperative-board-of-advisors/etcsummit2017.jpg": [
		73213,
		1,
		73213
	],
	"./2018-03-01-announcing-the-etc-cooperative-board-of-advisors/index.md": [
		16076,
		9,
		16076
	],
	"./2018-05-15-250k-funding-digital-finance-group/dfg.jpg": [
		70308,
		1,
		70308
	],
	"./2018-05-15-250k-funding-digital-finance-group/index.md": [
		89279,
		9,
		89279
	],
	"./2018-05-15-announcing-new-members-of-the-etc-cooperative/ecc.jpeg": [
		93411,
		1,
		93411
	],
	"./2018-05-15-announcing-new-members-of-the-etc-cooperative/index.md": [
		77879,
		9,
		77879
	],
	"./2018-07-09-2018-mid-year-review/ecc.jpeg": [
		15723,
		1,
		15723
	],
	"./2018-07-09-2018-mid-year-review/index.md": [
		77487,
		9,
		77487
	],
	"./2019-03-28-2018-end-of-year-review/ecc.jpeg": [
		70114,
		1,
		70114
	],
	"./2019-03-28-2018-end-of-year-review/index.md": [
		8122,
		9,
		8122
	],
	"./2019-09-10-etc-support-in-hyperledger-besu/hyperledger_besu.png": [
		30932,
		1,
		30932
	],
	"./2019-09-10-etc-support-in-hyperledger-besu/index.md": [
		11697,
		9,
		11697
	],
	"./2019-09-12-etc-cooperative-applying-to-join-eea/eea_rebel_alliance.jpeg": [
		94640,
		1,
		94640
	],
	"./2019-09-12-etc-cooperative-applying-to-join-eea/index.md": [
		37439,
		9,
		37439
	],
	"./2019-10-06-pow-mining-explicit-social-contract/TransparentPNG.png": [
		73252,
		1,
		73252
	],
	"./2019-10-06-pow-mining-explicit-social-contract/index.md": [
		12473,
		9,
		12473
	],
	"./2019-10-17-yaz-contract-extension/bob_and_yaz.jpeg": [
		6380,
		1,
		6380
	],
	"./2019-10-17-yaz-contract-extension/index.md": [
		70723,
		9,
		70723
	],
	"./2019-10-18-etc-coop-joins-eea/eea.jpeg": [
		40869,
		1,
		40869
	],
	"./2019-10-18-etc-coop-joins-eea/eea_launch.jpeg": [
		66225,
		1,
		66225
	],
	"./2019-10-18-etc-coop-joins-eea/etc-coop.png": [
		80099,
		1,
		80099
	],
	"./2019-10-18-etc-coop-joins-eea/index.md": [
		73773,
		9,
		73773
	],
	"./2019-10-19-alison-alexis-joins-etc-coop/alison.jpeg": [
		41409,
		1,
		41409
	],
	"./2019-10-19-alison-alexis-joins-etc-coop/index.md": [
		93234,
		9,
		93234
	],
	"./2019-10-19-bob-summerwill-to-speak-at/gdasummit_bob.jpeg": [
		62718,
		1,
		62718
	],
	"./2019-10-19-bob-summerwill-to-speak-at/index.md": [
		89926,
		9,
		89926
	],
	"./2019-12-23-coop-contributes-ethercluster-to-hyperledger-labs/ethercluster.png": [
		265,
		1,
		265
	],
	"./2019-12-23-coop-contributes-ethercluster-to-hyperledger-labs/index.md": [
		89845,
		9,
		89845
	],
	"./2019-12-23-coop-contributes-ethercluster-to-hyperledger-labs/yaz_headshot_bw.jpg": [
		97618,
		1,
		97618
	],
	"./2020-01-05-etc-agharta-update/agharta.png": [
		30426,
		1,
		30426
	],
	"./2020-01-05-etc-agharta-update/index.md": [
		50886,
		9,
		50886
	],
	"./2020-01-07-vyper-support-comes-to-etc/index.md": [
		54944,
		9,
		54944
	],
	"./2020-01-07-vyper-support-comes-to-etc/vyper.png": [
		84288,
		1,
		84288
	],
	"./2020-01-12-etc-successfully-hardforks-to-agharta/agharta.png": [
		62695,
		1,
		62695
	],
	"./2020-01-12-etc-successfully-hardforks-to-agharta/index.md": [
		19893,
		9,
		19893
	],
	"./2020-01-19-grayscale-extends-support-of-etc-cooperative/GrayscaleBlock.jpg": [
		91904,
		1,
		91904
	],
	"./2020-01-19-grayscale-extends-support-of-etc-cooperative/index.md": [
		602,
		9,
		602
	],
	"./2020-01-24-donations/TransparentPNG.png": [
		82812,
		1,
		82812
	],
	"./2020-01-24-donations/index.md": [
		38481,
		9,
		38481
	],
	"./2020-01-26-etc-phoenix-hardfork/BG-Phoenix-Green-Wires.png": [
		23256,
		1,
		23256
	],
	"./2020-01-26-etc-phoenix-hardfork/index.md": [
		70074,
		9,
		70074
	],
	"./2020-01-31-core-devs-call-ecip-1078-phoenix-upgrade/BG-Phoenix-Green-Wires.png": [
		98063,
		1,
		98063
	],
	"./2020-01-31-core-devs-call-ecip-1078-phoenix-upgrade/index.md": [
		63069,
		9,
		63069
	],
	"./2020-02-10-etc-coop-support-switch-to-keccak256/index.md": [
		75137,
		9,
		75137
	],
	"./2020-02-10-etc-coop-support-switch-to-keccak256/tsankov.jpeg": [
		15330,
		1,
		15330
	],
	"./2020-02-28-update-on-etc-phoenix-hardfork/index.md": [
		8357,
		9,
		8357
	],
	"./2020-02-28-update-on-etc-phoenix-hardfork/phoenix2.png": [
		1406,
		1,
		1406
	],
	"./2020-03-09-bob-summerwill-joins-eea-technical-spec-wg-as-a-vice-chair/index.md": [
		63478,
		9,
		63478
	],
	"./2020-03-09-bob-summerwill-joins-eea-technical-spec-wg-as-a-vice-chair/shahan.jpeg": [
		15080,
		1,
		15080
	],
	"./2020-03-17-etc-cooperative-agm-2020-new-governance/agenda.png": [
		49597,
		1,
		49597
	],
	"./2020-03-17-etc-cooperative-agm-2020-new-governance/index.md": [
		7503,
		9,
		7503
	],
	"./2020-03-24-yaz-khoury-joins-eea-testnet-wg-as-vice-chair/conor_bob_yaz.jpg": [
		68955,
		1,
		68955
	],
	"./2020-03-24-yaz-khoury-joins-eea-testnet-wg-as-vice-chair/index.md": [
		57627,
		9,
		57627
	],
	"./2020-03-27-etc-cooperative-website-relaunched/index.md": [
		64155,
		9,
		64155
	],
	"./2020-03-27-etc-cooperative-website-relaunched/website-relaunch.png": [
		79595,
		1,
		79595
	],
	"./2020-04-13-etc-cooperative-2019-retrospective-released/index.md": [
		58772,
		9,
		58772
	],
	"./2020-04-13-etc-cooperative-2019-retrospective-released/retrospective.png": [
		89827,
		1,
		89827
	],
	"./2020-04-23-etc-foundations-consensus-distributed/consensus.jpg": [
		46774,
		1,
		46774
	],
	"./2020-04-23-etc-foundations-consensus-distributed/index.md": [
		74361,
		9,
		74361
	],
	"./2020-04-30-etc-cooperative-q1-2020-transparency-report/index.md": [
		25636,
		9,
		25636
	],
	"./2020-04-30-etc-cooperative-q1-2020-transparency-report/transparency.png": [
		96080,
		1,
		96080
	],
	"./2020-05-06-consensus-bob-and-yaz-speaking/bob_and_yaz.jpeg": [
		38508,
		1,
		38508
	],
	"./2020-05-06-consensus-bob-and-yaz-speaking/index.md": [
		74723,
		9,
		74723
	],
	"./2020-05-20-phoenix-hardfork/index.md": [
		89817,
		9,
		89817
	],
	"./2020-05-20-phoenix-hardfork/q9f.png": [
		68891,
		1,
		68891
	],
	"./2020-05-22-etc-cooperative-april-2020-report/April2020.png": [
		28051,
		1,
		28051
	],
	"./2020-05-22-etc-cooperative-april-2020-report/index.md": [
		6981,
		9,
		6981
	],
	"./2020-07-02-kevin-lord-joins-etc-coop/BobAndKevin.jpg": [
		70129,
		1,
		70129
	],
	"./2020-07-02-kevin-lord-joins-etc-coop/index.md": [
		3218,
		9,
		3218
	],
	"./2020-07-17-etc-connext-state-channels/etc_connext.png": [
		9305,
		1,
		9305
	],
	"./2020-07-17-etc-connext-state-channels/index.md": [
		40139,
		9,
		40139
	],
	"./2020-08-02-51-percent-attack/hacker.jpg": [
		4378,
		1,
		4378
	],
	"./2020-08-02-51-percent-attack/index.md": [
		38142,
		9,
		38142
	],
	"./2020-08-19-etc-network-security-plan/index.md": [
		17441,
		9,
		17441
	],
	"./2020-08-19-etc-network-security-plan/padlocks.jpg": [
		93982,
		1,
		71601
	],
	"./2020-09-16-staffing-changes/index.md": [
		34767,
		9,
		34767
	],
	"./2020-09-16-staffing-changes/stev_and_kevin.jpg": [
		99189,
		1,
		99189
	],
	"./2020-09-29-Migrate-To-Hyperledger-Besu/hyperledger_besu_etc_-750x375.jpeg": [
		89714,
		1,
		89714
	],
	"./2020-09-29-Migrate-To-Hyperledger-Besu/index.md": [
		35774,
		9,
		35774
	],
	"./2020-10-20-ensuring-etc-network-security/etcalert.jpeg": [
		84137,
		1,
		84137
	],
	"./2020-10-20-ensuring-etc-network-security/index.md": [
		74618,
		9,
		74618
	],
	"./2020-10-27-subscribe-to-etc-weekly-newsletter/index.md": [
		43414,
		9,
		43414
	],
	"./2020-10-27-subscribe-to-etc-weekly-newsletter/newsletter.jpg": [
		66605,
		1,
		66605
	],
	"./2020-10-30-ETC-Weekly-0/etc-weekly0.png": [
		21934,
		1,
		21934
	],
	"./2020-10-30-ETC-Weekly-0/index.md": [
		70128,
		9,
		70128
	],
	"./2020-11-16-etc-cooperative-q3-2020-transparency-report/index.md": [
		6688,
		9,
		6688
	],
	"./2020-11-16-etc-cooperative-q3-2020-transparency-report/transparency.png": [
		79508,
		1,
		79508
	],
	"./2020-11-23-thanos-hard-fork-this-week/index.md": [
		77658,
		9,
		77658
	],
	"./2020-11-23-thanos-hard-fork-this-week/thanos.png": [
		45915,
		1,
		45915
	],
	"./2020-12-02-why-keccak/article_banner.png": [
		57416,
		1,
		57416
	],
	"./2020-12-02-why-keccak/index.md": [
		31041,
		9,
		31041
	],
	"./2021-01-13-why-treasury/index.md": [
		91021,
		9,
		91021
	],
	"./2021-01-13-why-treasury/why_treasury.png": [
		55301,
		1,
		55301
	],
	"./2021-01-19-2020-retrospective/2020-retro-spec.png": [
		16100,
		1,
		16100
	],
	"./2021-01-19-2020-retrospective/index.md": [
		96083,
		9,
		96083
	],
	"./2021-04-06-january-february-board-package/index.md": [
		69515,
		9,
		69515
	],
	"./2021-04-06-january-february-board-package/phoenix_banner.png": [
		55039,
		1,
		55039
	],
	"./2021-04-23-treasury-polls/article_banner.png": [
		10156,
		1,
		10156
	],
	"./2021-04-23-treasury-polls/index.md": [
		88181,
		9,
		88181
	],
	"./2021-05-11-q1-2021/article_banner.png": [
		13478,
		1,
		13478
	],
	"./2021-05-11-q1-2021/index.md": [
		26215,
		9,
		26215
	],
	"./2021-07-08-charles-hoskinson-joins-etc-coop-board/Charles_Hoskinson_profile_color_no_background.png": [
		48536,
		1,
		48536
	],
	"./2021-07-08-charles-hoskinson-joins-etc-coop-board/index.md": [
		5726,
		9,
		5726
	],
	"./2021-09-08-welcome-diego/diego_bw.jpeg": [
		49367,
		1,
		49367
	],
	"./2021-09-08-welcome-diego/index.md": [
		55074,
		9,
		55074
	],
	"./2021-09-20-withdraws-support-for-ecip-1098/index.md": [
		4891,
		9,
		4891
	],
	"./2021-09-20-withdraws-support-for-ecip-1098/proto-treasury.png": [
		31965,
		1,
		31965
	],
	"./2021-09-23-july-august-board-package/board-package.png": [
		40339,
		1,
		40339
	],
	"./2021-09-23-july-august-board-package/index.md": [
		5532,
		9,
		5532
	],
	"./2021-11-02-switch-to-rivet/index.md": [
		6989,
		9,
		6989
	],
	"./2021-11-02-switch-to-rivet/retro.jpeg": [
		85816,
		1,
		85816
	],
	"./2021-11-26-q3-october-board-package/index.md": [
		60645,
		9,
		60645
	],
	"./2021-11-26-q3-october-board-package/screen-shot.png": [
		28102,
		1,
		28102
	],
	"./2021-12-22-coop-now-funding-core-geth/etc-core.png": [
		78766,
		1,
		78766
	],
	"./2021-12-22-coop-now-funding-core-geth/index.md": [
		40894,
		9,
		40894
	],
	"./2022-01-27-mystique-hard-fork/index.md": [
		41711,
		9,
		41711
	],
	"./2022-01-27-mystique-hard-fork/mystique.png": [
		68694,
		1,
		68694
	],
	"./2022-04-12-2021-retrospective-2022-budget-roadmap/index.md": [
		21583,
		9,
		21583
	],
	"./2022-04-12-2021-retrospective-2022-budget-roadmap/resolutions.png": [
		66128,
		1,
		66128
	],
	"./2022-05-26-q1-board-package/index.md": [
		26724,
		9,
		26724
	],
	"./2022-05-26-q1-board-package/screen-shot.png": [
		95373,
		1,
		95373
	],
	"./2022-08-08-open-letter-to-chandler-guo/chandler.jpeg": [
		44966,
		1,
		44966
	],
	"./2022-08-08-open-letter-to-chandler-guo/index.md": [
		21098,
		9,
		21098
	],
	"./2022-08-15-etc-cooperative-discord-server/etccooperative.jpg": [
		33265,
		1,
		33265
	],
	"./2022-08-15-etc-cooperative-discord-server/index.md": [
		39944,
		9,
		39944
	],
	"./2022-08-24-q2-report/index.md": [
		80253,
		9,
		80253
	],
	"./2022-08-24-q2-report/screen-shot.png": [
		734,
		1,
		734
	],
	"./2022-09-26-history-of-the-cooperative/index.md": [
		53072,
		9,
		53072
	],
	"./2022-09-26-history-of-the-cooperative/screen-shot.png": [
		73993,
		1,
		73993
	],
	"./2022-11-08-etc-cooperative-is-attending-the-world-digital-mining-summit-wdms-en/bob-wdms.jpeg": [
		56848,
		1,
		56848
	],
	"./2022-11-08-etc-cooperative-is-attending-the-world-digital-mining-summit-wdms-en/index.md": [
		1086,
		9,
		1086
	],
	"./2022-11-10-ethereum-classic-safe-multisig-wallet-review-en/etc-safe-banner.png": [
		66005,
		1,
		66005
	],
	"./2022-11-10-ethereum-classic-safe-multisig-wallet-review-en/index.md": [
		12946,
		9,
		12946
	],
	"./2022-11-15-announcing-the-new-etc-cooperative-communications-team-en/ETC-Coop-comms-team-banner.png": [
		95108,
		1,
		95108
	],
	"./2022-11-15-announcing-the-new-etc-cooperative-communications-team-en/index.md": [
		68583,
		9,
		68583
	],
	"./2022-11-16-outline-of-xmei-lins-and-bob-summerwills-speeches-at-bitmain-wdsm-global-2022-en/index.md": [
		2991,
		9,
		2991
	],
	"./2022-11-16-outline-of-xmei-lins-and-bob-summerwills-speeches-at-bitmain-wdsm-global-2022-en/wdms-xmei-and-bob.png": [
		71601,
		1,
		93982
	],
	"./2022-11-17-q3-report-en/index.md": [
		12428,
		9,
		12428
	],
	"./2022-11-17-q3-report-en/q3-2022-report-banner.png": [
		51353,
		1,
		51353
	],
	"./2022-11-22-etc-cooperatives-mission-and-projects-with-bob-summerwill-en/bob-interview-banner.png": [
		11401,
		1,
		11401
	],
	"./2022-11-22-etc-cooperatives-mission-and-projects-with-bob-summerwill-en/index.md": [
		99837,
		9,
		99837
	],
	"./2022-11-23-the-etc-cooperatives-communications-plan-en/etc-cooperative-comms-plan.png": [
		37995,
		1,
		37995
	],
	"./2022-11-23-the-etc-cooperatives-communications-plan-en/index.md": [
		51213,
		9,
		51213
	],
	"./2022-12-28-core-geth-explained-with-etc-core-developer-isaac-ardis-en/index.md": [
		51916,
		9,
		51916
	],
	"./2022-12-28-core-geth-explained-with-etc-core-developer-isaac-ardis-en/isaac-interview-banner.png": [
		27932,
		1,
		27932
	],
	"./2023-01-02-the-ethereum-classic-rpc-url-is-changing-from-ethercluster-to-rivet-en/index.md": [
		8085,
		9,
		8085
	],
	"./2023-01-02-the-ethereum-classic-rpc-url-is-changing-from-ethercluster-to-rivet-en/rivet-article-banner.png": [
		65563,
		1,
		65563
	],
	"./2023-01-11-hyperledger-besu-explained-with-etc-core-developer-diego-lopez-leon-en/index.md": [
		66813,
		9,
		66813
	],
	"./2023-01-11-hyperledger-besu-explained-with-etc-core-developer-diego-lopez-leon-en/interview-hyperledger-besu-banner.png": [
		35129,
		1,
		35129
	],
	"./2023-01-31-egd-etc-grants-dao-announcement-en/2023-01-31-bitmain.jpg": [
		82002,
		1,
		82002
	],
	"./2023-01-31-egd-etc-grants-dao-announcement-en/index.md": [
		74559,
		9,
		74559
	],
	"./2023-01-31-etclabscore_core-geth-docker-tag-version-fmt-deprecation-en/core-geth.png": [
		86087,
		1,
		86087
	],
	"./2023-01-31-etclabscore_core-geth-docker-tag-version-fmt-deprecation-en/index.md": [
		32823,
		9,
		32823
	],
	"./2023-01-31-the-etc-grants-dao-explained-with-bob-summerwill-en/etc-grants-program-banner.png": [
		92656,
		1,
		92656
	],
	"./2023-01-31-the-etc-grants-dao-explained-with-bob-summerwill-en/index.md": [
		33344,
		9,
		33344
	],
	"./2023-02-01-pledge-to-the-ethereum-classic-community-with-regard-to-the-eth_classic-twitter-account-en/etc-twitter-acc.png": [
		73201,
		1,
		73201
	],
	"./2023-02-01-pledge-to-the-ethereum-classic-community-with-regard-to-the-eth_classic-twitter-account-en/index.md": [
		23803,
		9,
		23803
	],
	"./2023-03-03-ETC-cooperatives-bob-summerwill-will-be-speaking-today-at-ethdenver-en/bob-ethdenver-2023.png": [
		77858,
		1,
		77858
	],
	"./2023-03-03-ETC-cooperatives-bob-summerwill-will-be-speaking-today-at-ethdenver-en/index.md": [
		65315,
		9,
		65315
	],
	"./2023-03-06-outline-of-bob-summerwills-speech-at-ethdenver-2023-en/bob-ethdenver.png": [
		76502,
		1,
		76502
	],
	"./2023-03-06-outline-of-bob-summerwills-speech-at-ethdenver-2023-en/index.md": [
		41211,
		9,
		41211
	],
	"./2023-04-13-etc-cooperative-adds-core-geth-support-of-etc-mainnet-and-testnet-to-dappnode-en/dappnode.png": [
		86381,
		1,
		86381
	],
	"./2023-04-13-etc-cooperative-adds-core-geth-support-of-etc-mainnet-and-testnet-to-dappnode-en/index.md": [
		46374,
		9,
		46374
	],
	"./2023-05-01-announcing-the-proof-of-work-summit-securing-blockchains-future-en/index.md": [
		48644,
		9,
		48644
	],
	"./2023-05-01-announcing-the-proof-of-work-summit-securing-blockchains-future-en/pow-summit-social.png": [
		86914,
		1,
		86914
	],
	"./2023-05-15-addressing-practical-attacks-on-core-geth-synchronising-nodes-by-taverna-and-paterson-en/index.md": [
		84418,
		9,
		84418
	],
	"./2023-05-15-addressing-practical-attacks-on-core-geth-synchronising-nodes-by-taverna-and-paterson-en/practical-attacks.png": [
		90243,
		1,
		90243
	],
	"./2023-05-18-ETC-Cooperative-Hired-Law-Firm-to-Claim-ETCs-Twitter-Handle-ETH-Classic-en/index.md": [
		83516,
		9,
		83516
	],
	"./2023-05-18-ETC-Cooperative-Hired-Law-Firm-to-Claim-ETCs-Twitter-Handle-ETH-Classic-en/twitter-handle-claim.png": [
		91865,
		1,
		91865
	],
	"./2023-05-18-the-etc-cooperative-2022-retrospective-report-en/2022-retro.png": [
		49031,
		1,
		49031
	],
	"./2023-05-18-the-etc-cooperative-2022-retrospective-report-en/index.md": [
		21376,
		9,
		21376
	],
	"./2023-05-19-the-etc-cooperative-goals-budget-and-AGM-reports-2023-en/goals-budget-2023.png": [
		88760,
		1,
		88760
	],
	"./2023-05-19-the-etc-cooperative-goals-budget-and-AGM-reports-2023-en/index.md": [
		11100,
		9,
		11100
	],
	"./2023-05-26-pow-summit-2023-speaker-spotlight-en/index.md": [
		33928,
		9,
		33928
	],
	"./2023-05-26-pow-summit-2023-speaker-spotlight-en/pow-summit-banner.png": [
		52517,
		1,
		52517
	],
	"./2023-06-02-pow-summit-2023-speaker-spotlight-en/index.md": [
		72295,
		9,
		72295
	],
	"./2023-06-02-pow-summit-2023-speaker-spotlight-en/pow-summit-banner-2.jpg": [
		34609,
		1,
		34609
	],
	"./2023-06-05-evm-compatibility-on-ethereum-classic-for-solidity-developers-en/evm-comp.png": [
		90873,
		1,
		90873
	],
	"./2023-06-05-evm-compatibility-on-ethereum-classic-for-solidity-developers-en/index.md": [
		82061,
		9,
		82061
	],
	"./2023-06-09-pow-summit-2023-speaker-spotlight-3-en/index.md": [
		91228,
		9,
		91228
	],
	"./2023-06-09-pow-summit-2023-speaker-spotlight-3-en/speaker-ann-3.jpg": [
		91957,
		1,
		91957
	],
	"./2023-06-16-pow-summit-2023-speaker-spotlight-4-en/index.md": [
		31139,
		9,
		31139
	],
	"./2023-06-16-pow-summit-2023-speaker-spotlight-4-en/speaker-ann-4.jpg": [
		11599,
		1,
		11599
	],
	"./2023-06-24-important-announcement-migrate-the-etc-and-mordor-rpc-endpoints-by-july-24-2023-en/banner-en.png": [
		61696,
		1,
		61696
	],
	"./2023-06-24-important-announcement-migrate-the-etc-and-mordor-rpc-endpoints-by-july-24-2023-en/index.md": [
		28962,
		9,
		28962
	],
	"./2023-06-30-pow-summit-2023-speaker-spotlight-5-en/index.md": [
		16618,
		9,
		16618
	],
	"./2023-06-30-pow-summit-2023-speaker-spotlight-5-en/speaker-ann-5.png": [
		3829,
		1,
		3829
	],
	"./2023-06-30-q1-report-en/index.md": [
		85746,
		9,
		85746
	],
	"./2023-06-30-q1-report-en/q1-2023-report-banner.png": [
		14596,
		1,
		14596
	],
	"./2023-07-14-pow-summit-2023-speaker-spotlight-6-en/index.md": [
		64064,
		9,
		64064
	],
	"./2023-07-14-pow-summit-2023-speaker-spotlight-6-en/speaker-ann-6.png": [
		16852,
		1,
		16852
	],
	"./2023-07-19-etc-grants-dao-announcement-en/etc-grants-dao-banner.png": [
		91908,
		1,
		91908
	],
	"./2023-07-19-etc-grants-dao-announcement-en/index.md": [
		86928,
		9,
		86928
	],
	"./2023-07-20-celebrating-ethereum-classics-independence-day-en/etc-independence-2023.png": [
		62186,
		1,
		62186
	],
	"./2023-07-20-celebrating-ethereum-classics-independence-day-en/index.md": [
		84253,
		9,
		84253
	],
	"./2023-07-21-announcing-the-first-round-winners-of-the-etc-grants-dao-program-en/first-round-grant-winners.png": [
		88029,
		1,
		88029
	],
	"./2023-07-21-announcing-the-first-round-winners-of-the-etc-grants-dao-program-en/index.md": [
		69282,
		9,
		69282
	],
	"./2023-07-21-pow-summit-2023-speaker-spotlight-7-en/index.md": [
		54585,
		9,
		54585
	],
	"./2023-07-21-pow-summit-2023-speaker-spotlight-7-en/speaker-ann-7.png": [
		39018,
		1,
		39018
	],
	"./2023-07-24-presenting-first-round-etc-grants-dao-winner-patient-money-en/index.md": [
		43603,
		9,
		43603
	],
	"./2023-07-24-presenting-first-round-etc-grants-dao-winner-patient-money-en/patient-money-banner.png": [
		10674,
		1,
		10674
	],
	"./2023-07-27-presenting-first-round-etc-grants-dao-winner-classicdao-en/banner-classicDAO.png": [
		40321,
		1,
		40321
	],
	"./2023-07-27-presenting-first-round-etc-grants-dao-winner-classicdao-en/index.md": [
		386,
		9,
		386
	],
	"./2023-07-31-presenting-first-round-etc-grants-dao-winner-hebeswap-oracle-en/hebeswap-oracle-banner.png": [
		51928,
		1,
		51928
	],
	"./2023-07-31-presenting-first-round-etc-grants-dao-winner-hebeswap-oracle-en/index.md": [
		86139,
		9,
		86139
	],
	"./2023-08-01-bob-summerwill-will-be-speaking-at-the-5th-annual-blockchain-futurist-conference-en/bob-bfc-banner.png": [
		40065,
		1,
		40065
	],
	"./2023-08-01-bob-summerwill-will-be-speaking-at-the-5th-annual-blockchain-futurist-conference-en/index.md": [
		50187,
		9,
		50187
	],
	"./2023-08-03-presenting-first-round-etc-grants-dao-winner-nervenetwork-en/index.md": [
		21559,
		9,
		21559
	],
	"./2023-08-03-presenting-first-round-etc-grants-dao-winner-nervenetwork-en/nervenetwork-banner.png": [
		15516,
		1,
		15516
	],
	"./2023-08-04-presenting-first-round-etc-grants-dao-winner-timesfinance-en/index.md": [
		31514,
		9,
		31514
	],
	"./2023-08-04-presenting-first-round-etc-grants-dao-winner-timesfinance-en/timesfinance-banner.png": [
		66349,
		1,
		66349
	],
	"./2023-08-07-presenting-first-round-etc-grants-dao-winner-mechaverse-en/index.md": [
		26422,
		9,
		26422
	],
	"./2023-08-07-presenting-first-round-etc-grants-dao-winner-mechaverse-en/mechaverse-banner.png": [
		28564,
		1,
		28564
	],
	"./2023-08-08-presenting-first-round-etc-grants-dao-winner-ETC-Fans-en/etc-fans-banner-1.png": [
		28819,
		1,
		28819
	],
	"./2023-08-08-presenting-first-round-etc-grants-dao-winner-ETC-Fans-en/index.md": [
		21339,
		9,
		21339
	],
	"./2023-08-09-presenting-first-round-etc-grants-dao-winner-blockscout-en/blockscout-banner-1.png": [
		14792,
		1,
		14792
	],
	"./2023-08-09-presenting-first-round-etc-grants-dao-winner-blockscout-en/index.md": [
		86256,
		9,
		86256
	],
	"./2023-08-11-presenting-first-round-etc-grants-dao-winner-etc-radio-en/etc-radio-banner-1.png": [
		61279,
		1,
		61279
	],
	"./2023-08-11-presenting-first-round-etc-grants-dao-winner-etc-radio-en/index.md": [
		53776,
		9,
		53776
	],
	"./2023-08-17-presenting-first-round-etc-grants-dao-winner-plugeth-by-rivet-en/index.md": [
		99428,
		9,
		99428
	],
	"./2023-08-17-presenting-first-round-etc-grants-dao-winner-plugeth-by-rivet-en/plugeth-banner.png": [
		91102,
		1,
		91102
	],
	"./2023-08-18-presenting-first-round-etc-grants-dao-winner-izumi-en/index.md": [
		16331,
		9,
		16331
	],
	"./2023-08-18-presenting-first-round-etc-grants-dao-winner-izumi-en/izumi-banner-1.png": [
		19116,
		1,
		19116
	],
	"./2023-08-22-presenting-first-round-etc-grants-dao-winner-pow-summit-en/index.md": [
		89464,
		9,
		89464
	],
	"./2023-08-22-presenting-first-round-etc-grants-dao-winner-pow-summit-en/pow-summit-banner-2.png": [
		5308,
		1,
		5308
	],
	"./2023-08-23-presenting-first-round-etc-grants-dao-winner-alphaday-en/alphaday-banner-1.png": [
		88156,
		1,
		88156
	],
	"./2023-08-23-presenting-first-round-etc-grants-dao-winner-alphaday-en/index.md": [
		82453,
		9,
		82453
	],
	"./2023-08-24-pow-summit-2023-speaker-spotlight-8-en/index.md": [
		52782,
		9,
		52782
	],
	"./2023-08-24-pow-summit-2023-speaker-spotlight-8-en/speaker-ann-8.png": [
		45412,
		1,
		45412
	],
	"./2023-08-29-pow-summit-2023-speaker-spotlight-9-en/index.md": [
		22402,
		9,
		22402
	],
	"./2023-08-29-pow-summit-2023-speaker-spotlight-9-en/speaker-ann-9.png": [
		20289,
		1,
		20289
	],
	"./2023-08-30-presenting-first-round-etc-grants-dao-winner-magic-tower-en/index.md": [
		15952,
		9,
		15952
	],
	"./2023-08-30-presenting-first-round-etc-grants-dao-winner-magic-tower-en/magic-tower-banner.png": [
		28602,
		1,
		28602
	],
	"./2023-09-04-q2-report-en/index.md": [
		62495,
		9,
		62495
	],
	"./2023-09-04-q2-report-en/q2-2023-report-banner-en.png": [
		12292,
		1,
		12292
	],
	"./2023-10-09-presenting-the-alphaday-etc-dashboard-a-first-round-etc-grants-dao-project-en/alphaday-banner.png": [
		35323,
		1,
		35323
	],
	"./2023-10-09-presenting-the-alphaday-etc-dashboard-a-first-round-etc-grants-dao-project-en/index.md": [
		242,
		9,
		242
	],
	"./2023-10-10-presenting-first-round-etc-grants-dao-winner-giveth-en/giveth-banner.png": [
		87203,
		1,
		87203
	],
	"./2023-10-10-presenting-first-round-etc-grants-dao-winner-giveth-en/index.md": [
		18499,
		9,
		18499
	],
	"./2023-10-30-announcing-etc-grants-dao-first-round-project-completions-1-en/egd-projects-2.png": [
		90538,
		1,
		90538
	],
	"./2023-10-30-announcing-etc-grants-dao-first-round-project-completions-1-en/index.md": [
		19042,
		9,
		19042
	],
	"./2023-10-30-announcing-the-spiral-upgrade-on-the-etc-mordor-testnet-on-block-9957000-en/index.md": [
		59033,
		9,
		59033
	],
	"./2023-10-30-announcing-the-spiral-upgrade-on-the-etc-mordor-testnet-on-block-9957000-en/spiral-mordor.png": [
		6390,
		1,
		6390
	],
	"./2023-11-09-ethereum-classic-mordor-testnet-spiral-upgrade-emergency-patch-alert-en/emergency-mordor-patch.png": [
		29308,
		1,
		29308
	],
	"./2023-11-09-ethereum-classic-mordor-testnet-spiral-upgrade-emergency-patch-alert-en/index.md": [
		19850,
		9,
		19850
	],
	"./2023-11-14-core-geth-post-mortem-analysis-of-v1-12-15-en/banner.png": [
		1225,
		1,
		1225
	],
	"./2023-11-14-core-geth-post-mortem-analysis-of-v1-12-15-en/index.md": [
		77825,
		9,
		77825
	],
	"./2023-11-24-mc-michael-parenti-opens-up-the-inaugural-pow-summit-in-prague-2023-en/index.md": [
		76685,
		9,
		76685
	],
	"./2023-11-24-mc-michael-parenti-opens-up-the-inaugural-pow-summit-in-prague-2023-en/michael-parenti.png": [
		43986,
		1,
		43986
	],
	"./2023-11-30-q3-report-en/index.md": [
		27840,
		9,
		27840
	],
	"./2023-11-30-q3-report-en/q3-2023-report-banner-en.png": [
		64758,
		1,
		64758
	],
	"./2023-12-01-welcome-to-pow-summit-why-we-are-having-a-pow-summit-with-alan-austin-and-bob-summerwill-en/alan-bob.png": [
		70278,
		1,
		70278
	],
	"./2023-12-01-welcome-to-pow-summit-why-we-are-having-a-pow-summit-with-alan-austin-and-bob-summerwill-en/index.md": [
		19088,
		9,
		19088
	],
	"./2023-12-06-miner-autopause-vulnerability-disclosure-en/index.md": [
		87587,
		9,
		87587
	],
	"./2023-12-06-miner-autopause-vulnerability-disclosure-en/miner-autopause-vulnerability.png": [
		72975,
		1,
		72975
	],
	"./2023-12-08-keynote-jameson-lopp-hunting-bitcoins-real-hashrate-en/image.png": [
		64973,
		1,
		64973
	],
	"./2023-12-08-keynote-jameson-lopp-hunting-bitcoins-real-hashrate-en/index.md": [
		45942,
		9,
		45942
	],
	"./2023-12-13-announcement-upgrade-your-nodes-for-the-ethereum-classic-spiral-hard-fork-on-block-19250000-en/banner-1.png": [
		34523,
		1,
		34523
	],
	"./2023-12-13-announcement-upgrade-your-nodes-for-the-ethereum-classic-spiral-hard-fork-on-block-19250000-en/banner-2.png": [
		79488,
		1,
		79488
	],
	"./2023-12-13-announcement-upgrade-your-nodes-for-the-ethereum-classic-spiral-hard-fork-on-block-19250000-en/index.md": [
		65897,
		9,
		65897
	],
	"./2023-12-15-bitcoin-maximalism-and-breaking-fud-en/index.md": [
		35900,
		9,
		35900
	],
	"./2023-12-15-bitcoin-maximalism-and-breaking-fud-en/vlad-costea.png": [
		77451,
		1,
		77451
	],
	"./2023-12-22-amir-taaki-on-darkfi-anonymous-smart-contracts-with-pow-finality-en/index.md": [
		12872,
		9,
		12872
	],
	"./2023-12-22-amir-taaki-on-darkfi-anonymous-smart-contracts-with-pow-finality-en/taaki-banner.png": [
		17623,
		1,
		17623
	],
	"./2024-01-05-jasminers-victor-hou-why-pow-why-etc-en/banner.png": [
		39966,
		1,
		39966
	],
	"./2024-01-05-jasminers-victor-hou-why-pow-why-etc-en/hou-banner.png": [
		84927,
		1,
		84927
	],
	"./2024-01-05-jasminers-victor-hou-why-pow-why-etc-en/index.md": [
		174,
		9,
		174
	],
	"./2024-01-10-bob-summerwill-talks-about-environmental-and-energy-market-positives-of-crypto-mining-on-the-web3-podcast-en/bob-podcast.png": [
		44280,
		1,
		44280
	],
	"./2024-01-10-bob-summerwill-talks-about-environmental-and-energy-market-positives-of-crypto-mining-on-the-web3-podcast-en/index.md": [
		42334,
		9,
		42334
	],
	"./2024-01-12-frank-holmes--proof-of-work-drives-innovation-en/frank-banner.png": [
		31379,
		1,
		31379
	],
	"./2024-01-12-frank-holmes--proof-of-work-drives-innovation-en/index.md": [
		88494,
		9,
		88494
	],
	"./2024-01-17-bob-summerwill-etc-cooperatives-executive-director-will-be-speaking-at-the-litecoin-summit-en/bob-ltc-banner.png": [
		44485,
		1,
		44485
	],
	"./2024-01-17-bob-summerwill-etc-cooperatives-executive-director-will-be-speaking-at-the-litecoin-summit-en/index.md": [
		58839,
		9,
		58839
	],
	"./2024-01-19-panel-why-pow-is-good-for-humanity-and-the-world-en/banner-8.png": [
		32675,
		1,
		32675
	],
	"./2024-01-19-panel-why-pow-is-good-for-humanity-and-the-world-en/index.md": [
		32696,
		9,
		32696
	],
	"./2024-01-29-mining-in-virunga-park-how-crypto-mining-is-saving-gorillas-en/index.md": [
		13231,
		9,
		13231
	],
	"./2024-01-29-mining-in-virunga-park-how-crypto-mining-is-saving-gorillas-en/virunga-banner.png": [
		60860,
		1,
		60860
	],
	"./2024-02-09-history-never-repeats-itself-but-it-always-rhymes-en/index.md": [
		44217,
		9,
		44217
	],
	"./2024-02-09-history-never-repeats-itself-but-it-always-rhymes-en/marta-banner.png": [
		78991,
		1,
		78991
	],
	"./2024-02-16-mario-havel-ethereum-left-pow-what-now-en/havel-banner.png": [
		77167,
		1,
		77167
	],
	"./2024-02-16-mario-havel-ethereum-left-pow-what-now-en/index.md": [
		9940,
		9,
		9940
	],
	"./2024-03-01-litecoin-foundation-zero-downtime-through-pow-en/index.md": [
		6806,
		9,
		6806
	],
	"./2024-03-01-litecoin-foundation-zero-downtime-through-pow-en/ltc-foundation-banner.png": [
		67028,
		1,
		67028
	],
	"./2024-03-11-etc-grants-dao-update-the-growth-of-etc-radio-en/etc-radio-banner.png": [
		18171,
		1,
		18171
	],
	"./2024-03-11-etc-grants-dao-update-the-growth-of-etc-radio-en/index.md": [
		57038,
		9,
		57038
	],
	"./2024-03-15-litecoins-kerry-washington-mweb-workshop-en/index.md": [
		1169,
		9,
		1169
	],
	"./2024-03-15-litecoins-kerry-washington-mweb-workshop-en/washington-banner.png": [
		83566,
		1,
		83566
	],
	"./2024-03-22-caitlin-long-pow-keynote-speech-en/caitlin-long-banner.png": [
		63025,
		1,
		63025
	],
	"./2024-03-22-caitlin-long-pow-keynote-speech-en/index.md": [
		30405,
		9,
		30405
	],
	"./2024-03-29-the-etc-cooperative-2023-retrospective-report-en/2023-retro.png": [
		13384,
		1,
		13384
	],
	"./2024-03-29-the-etc-cooperative-2023-retrospective-report-en/index.md": [
		60034,
		9,
		60034
	],
	"./2024-03-29-the-etc-cooperative-goals-budget-and-AGM-reports-2024-en/goals-budget-2024.png": [
		17802,
		1,
		17802
	],
	"./2024-03-29-the-etc-cooperative-goals-budget-and-AGM-reports-2024-en/index.md": [
		45935,
		9,
		45935
	],
	"./2024-04-26-dr-maxim-orlovsky-prime-new-layer-1-for-bitcoin-miner-opportunities-en/index.md": [
		91656,
		9,
		91656
	],
	"./2024-04-26-dr-maxim-orlovsky-prime-new-layer-1-for-bitcoin-miner-opportunities-en/orlovsky-banner.png": [
		7208,
		1,
		7208
	],
	"./2024-04-27-pow-summit-announcement-speakers-en/index.md": [
		97511,
		9,
		97511
	],
	"./2024-04-27-pow-summit-announcement-speakers-en/pow2024-blog-post.png": [
		86659,
		1,
		86659
	],
	"./2024-04-27-pow-summit-announcement-speakers-en/test.txt": [
		16688,
		7,
		16688
	],
	"./2024-05-29-visit-ETC-Grants-DAO-Booth-at-Consensus-en/bitmain-austin.png": [
		68432,
		1,
		68432
	],
	"./2024-05-29-visit-ETC-Grants-DAO-Booth-at-Consensus-en/index.md": [
		95275,
		9,
		95275
	],
	"./2024-05-29-visit-ETC-Grants-DAO-Booth-at-Consensus-en/test.txt": [
		56580,
		7,
		56580
	],
	"./2024-06-12-presenting-the-ecsd-and-erusd-stablecoins-supported-by-the-etc-grants-dao-program-en/ecsd-erusd.png": [
		70268,
		1,
		70268
	],
	"./2024-06-12-presenting-the-ecsd-and-erusd-stablecoins-supported-by-the-etc-grants-dao-program-en/index.md": [
		94635,
		9,
		94635
	],
	"./2024-06-20-announcing-the-ethereum-classic-nashville-meetup-en/index.md": [
		15268,
		9,
		15268
	],
	"./2024-06-20-announcing-the-ethereum-classic-nashville-meetup-en/nashville-banner-1.png": [
		59705,
		1,
		59705
	],
	"./2024-07-01-q1-report-en/index.md": [
		14098,
		9,
		14098
	],
	"./2024-07-01-q1-report-en/q1-2024-report-banner-en.png": [
		4591,
		1,
		4591
	],
	"./2024-09-16-introducing-david-schwartz-alan-austin-and-donald-mcintyre-en/index.md": [
		7042,
		9,
		7042
	],
	"./2024-09-16-introducing-david-schwartz-alan-austin-and-donald-mcintyre-en/pows-1-banner.png": [
		92504,
		1,
		92504
	],
	"./2024-09-16-introducing-tor-ekeland-jullian-duran-and-magdalena-gronowska-en/index.md": [
		88064,
		9,
		88064
	],
	"./2024-09-16-introducing-tor-ekeland-jullian-duran-and-magdalena-gronowska-en/pows-1-banner.png": [
		37050,
		1,
		37050
	],
	"./2024-09-16-introducing-vlad-costea-michael-parenti-and-bob-summerwill-en/index.md": [
		39519,
		9,
		39519
	],
	"./2024-09-16-introducing-vlad-costea-michael-parenti-and-bob-summerwill-en/pows-1-banner.png": [
		31499,
		1,
		31499
	],
	"./2024-09-17-announcing-the-pow-summit-2024-schedule-en/index.md": [
		15540,
		9,
		15540
	],
	"./2024-09-17-announcing-the-pow-summit-2024-schedule-en/pows-schedule.jpg": [
		71001,
		1,
		71001
	],
	"./2024-09-17-announcing-the-pow-summit-2024-schedule-en/pows-schedule.png": [
		69089,
		1,
		69089
	],
	"./2024-12-05-q2-q3-reports/bob_pow_summit.jpg": [
		60457,
		1,
		60457
	],
	"./2024-12-05-q2-q3-reports/index.md": [
		73187,
		9,
		73187
	],
	"./2025-03-14-the-etc-cooperative-2024-retrospective-report-en/2024-retro.png": [
		43471,
		1,
		43471
	],
	"./2025-03-14-the-etc-cooperative-2024-retrospective-report-en/file.txt": [
		16899,
		7,
		16899
	],
	"./2025-03-14-the-etc-cooperative-2024-retrospective-report-en/index.md": [
		40118,
		9,
		40118
	],
	"./2025-06-03-staffing-changes-at-the-etc-cooperative-en/index.md": [
		91686,
		9,
		91686
	],
	"./2025-06-03-staffing-changes-at-the-etc-cooperative-en/staffing-changes.png": [
		11005,
		1,
		33386
	],
	"./2025-06-24-q1-report-en/index.md": [
		95491,
		9,
		95491
	],
	"./2025-06-24-q1-report-en/q1-2025-report-banner-en.png": [
		68121,
		1,
		68121
	],
	"./2025-09-01-q2-report-en/index.md": [
		58820,
		9,
		58820
	],
	"./2025-09-01-q2-report-en/q2-2025-report-banner-en.png": [
		42925,
		1,
		42925
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5825;
module.exports = webpackAsyncContext;